import React, { useEffect } from 'react';
import '../../assets/scss/pages/_fail.scss'

// routes
import { useNavigate } from 'react-router-dom';

function SignInRefusePage() {
	const navigate = useNavigate();
	function GoToSignInPage() {
		navigate('/sign-in');
	}

	useEffect(() => {
	}, []);

	return (
		<div>
			<button className="backward" onClick={() => {GoToSignInPage();}}>
				승인을 대기해주세요.
			</button>
		</div>
	);
}
export default SignInRefusePage;
